<template>
  <div class="t-app__container">
    <heading :title="$t('create-business-title')" />
    <div class="h-section h-section--no-margin-top">
      <div class="h-grid h-grid--justify-content-center">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <s-form @submit="createBusiness">
            <p class="m-form-group">
              <label class="a-form-label" for="name">{{ $t('label-business-name') }} <span :style="{ color: 'red' }">*</span></label>
              <input class="a-form-control" id="name" v-model.trim="$v.name.$model" autocomplete="create-business business-name" />
              <span v-if="$v.name.$dirty">
                <span class="m-form-group__error" v-if="!$v.name.required">{{ $t('error-field-required') }}</span>
              </span>
            </p>
            <administrative-region-select v-model.trim="$v.region.$model">
              <span v-if="$v.region.$dirty">
                <span class="m-form-group__error" v-if="!$v.region.regionIsValid">{{ $t('error-field-required') }}</span>
              </span>
            </administrative-region-select>
            <div class="m-form-ctrl">
              <div class="m-form-ctrl__item">
                <button class="a-btn-primary" type="submit">{{ $t('button-create-business') }}</button>
              </div>
              <div class="m-form-ctrl__item">
                <router-link :to="{ name: $consts.urls.URL_ROOT }">
                  {{ $t('return-login-btn') }}
                </router-link>
              </div>
            </div>
          </s-form>
        </div>
      </div>
    </div>

    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--03"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import Heading from '@/components/heading'
import SForm from '@/components/form/form'
import AdministrativeRegionSelect from '@/components/form/administrative-region-select'

import BusinessService from '@/services/business'
import NotificationService from '@/services/notification'

import i18n from '@/helpers/i18n'
import StatusHelper from '@/helpers/status'

import router from '@/router'

import { URL_EDIT_BUSINESS } from '@/consts/urls'

const regionIsValid = function(value) {
  return value > 0
}

export default {
  components: {
    SForm,
    Heading,
    AdministrativeRegionSelect
  },
  data() {
    return {
      name: '',
      region: 0
    }
  },
  validations: {
    name: {
      required
    },
    region: {
      regionIsValid
    }
  },
  methods: {
    createBusiness: async function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let response = await BusinessService.createBusiness(this.name, this.region)
        if (StatusHelper.isSuccess(response.status)) {
          NotificationService.showSuccess(i18n.t('business-create-success-notification'))
          const newBusiness = await response.json()
          router.push({ name: URL_EDIT_BUSINESS, params: { id: newBusiness.Id } })
        } else {
          NotificationService.showError(i18n.t('error-basic'))
        }
      }
    }
  }
}
</script>
